import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';
// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

export const API_ENDPOINTS = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  galery: {
    post: '/api/gallery',
    list: '/api/gallery',
    delete: '/api/gallery/',
    order: '/api/gallery/order'
  },
  carousel:{
    post: '/api/carousel',
    list: '/api/carousel',
    delete: '/api/carousel/',
    order: '/api/carousel/order'
  },
  menu: {
    post: '/api/menu',
    edit: '/api/menu/',
    list: '/api/menu',
    add_dish: '/api/menu',
    delete: '/api/menu',
    manual_dish: '/api/menu',
    daily_dish_mode: '/api/menu'
  },
  translate: {
    post: '/api/translate'
  },
  menutype: {
    post:  '/api/menutype',
    get: '/api/menutype/',
    list: '/api/menutype',
    update: '/api/menutype',
    delete: '/api/menutype/'
  },
  dish: {
    post: '/api/dish',
    get: '/api/dish/',
    list: '/api/dish',
    update: '/api/dish',
    delete: 'api/dish/',
    list_by_category_id: 'api/dish/category/'
  },
  dishcategory: {
    post:  '/api/dishcategory',
    get: '/api/dishcategory/',
    list: '/api/dishcategory',
    update: '/api/dishcategory',
    delete: '/api/dishcategory/'
  },
  users: {
    list: '/api/users',
    get: '/api/users/',
    create: '/api/users',
    update: '/api/users/',
    delete: '/api/users/',
    password: '/api/users/',
    status: '/api/users/'
  },
  reservations: {
    list: '/api/reservation/list',
    updateStatus: '/api/reservation/'
  },
  allergen: {
    post: '/api/allergen',
    get: '/api/allergen/',
    list: '/api/allergen',
    update: '/api/allergen',
    delete: '/api/allergen/'
  },
  stats: {
    dashboard: '/api/stats/dashboard',
    reservationsChart: '/api/stats/reservations-chart'
  },
  businessHours: {
    list: '/api/business-hours',
    update: '/api/business-hours',
    availability: '/api/business-hours/availability',
    closedDates: '/api/business-hours/closed-dates',
    deleteClosedDate: '/api/business-hours/closed-dates/'
  },
};
